module.exports = __webpack_public_path__ + "img/outed.4e82b4fc.png";